var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.mobile)?_c('div',{staticClass:"bottom__navigation d-flex align-center"},[_c('shirts-action-buttons',{attrs:{"active":_vm.btnInView},on:{"add-text":function($event){_vm.addText=true},"change":_vm.SET_BTN_IN_VIEW}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }